import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, ModalService } from '@app/core/services';
import { updateUserPreference } from '@app/core/store/actions/user.actions';
import { AppState } from '@app/core/store/reducers';
import { selectUsersState } from '@app/core/store/reducers/users.reducer';
import { User } from '@core/models';
import { Store } from '@ngrx/store';
import { MessageModalComponent } from '@shared/message-modal.component';

@Component({
  standalone: false,
  selector: 'app-user-preferences',
  templateUrl: 'user-preferences.component.html'
})
export class UserPreferencesComponent {

  user: User;
  form: FormGroup = null;
  primaryButtonText = 'Save';

  constructor(protected store: Store<AppState>, protected formBuilder: FormBuilder, protected modalService: ModalService,
    protected router: Router, protected authService: AuthService) {

    store.select(selectUsersState).subscribe(usersState => {
      this.user = usersState.user;
      
      if (this.user) {
        this.buildForm();
      }
    });
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      sendSearchResultEmail: [this.user ? this.user.sendSearchResultEmail : false]
    });
  }

  onSave(): void {
    const formValues = this.form.getRawValue();
    let updateUser = User.userFactory(this.user);
    updateUser.sendSearchResultEmail = formValues.sendSearchResultEmail;
    this.store.dispatch(updateUserPreference({ user: updateUser }))
  }
}